module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm-head",
    attrs: {
      "id": "fm01-001"
    }
  }, [_c('b', [_vm._v("DEDICATION")])]), _vm._v(" "), _c('p', {
    staticClass: "dedicat"
  }, [_c('i', [_vm._v("For my family:")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_c('span', {
    staticClass: "txt_blue"
  }, [_vm._v("To my husband, Sam,")]), _vm._v(" who always wanted me to write a book … though I’m quite certain this wasn’t what you had in mind.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_c('span', {
    staticClass: "txt_blue"
  }, [_vm._v("To my three joyful, fiery, and nonpareil daughters")]), _vm._v("—Jettie, Florence, and Nell—you are pure bliss.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_c('span', {
    staticClass: "txt_blue"
  }, [_vm._v("To my siblings")]), _vm._v(", for all the love.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_c('span', {
    staticClass: "txt_blue"
  }, [_vm._v("And to my parents")]), _vm._v(", for affording me the desire to fish (and for teaching me to quilt—thanks, Mom).")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ed8d6e4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/03_dedication.vue
// module id = 63
// module chunks = 0